// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-style1[data-v-57e48ec3] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
}
.indicator-style1 .indicator-style-item-content[data-v-57e48ec3] {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/indicatorStyle/style1.vue","webpack://./style1.vue"],"names":[],"mappings":"AA6CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AC5CF;ADwCA;EAOI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AC5CJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.indicator-style1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n\n  .indicator-style-item-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-left: 12px;\n  }\n}\n",".indicator-style1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n}\n.indicator-style1 .indicator-style-item-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
